<template>
  <section>
    <!--Cabeçalho de consulta-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form ref="formRule" :model="formRule" label-width="80px" size="mini">
        <el-col :span="12">
          <el-form-item label="CNPJ">
            <el-select style="width:274px" v-on:change="cleanListaNfe" v-model="formRule.cnpjSel"
              placeholder="Selecione o CNPJ">
              <el-option v-for="item in formRule.cnpjObj" :key="item.cnpj" :label="item.apelido" :value="item.cnpj">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Chave">
            <el-input style="width:390px" :disabled="formRule.selecao === 'N'"
              v-mask="'#### #### #### #### #### #### #### #### #### #### ####'" v-model="formRule.nfeChave"
              v-on:change="cleanListaNfe" clearable placeholder="Chave de acesso da NF-e"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Buscar por">
            <el-radio-group v-model="formRule.tipo" v-on:change="changeSelecao">
              <el-radio-button label="C">Chave NF-e</el-radio-button>
              <el-radio-button label="N">Número/Série</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Número">
            <el-input style="width:100px" :disabled="formRule.selecao === 'C'" v-mask="'##########'"
              v-model="formRule.nfeNumero" v-on:change="cleanListaNfe" clearable placeholder="Número"></el-input>
            <el-input style="width:75px" :disabled="formRule.selecao === 'C'" v-mask="'###'" v-model="formRule.nfeSerie"
              v-on:change="cleanListaNfe" clearable placeholder="Série"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading=formRule.listLoading
              @click.native.prevent="getListaNfe(null, null)">Buscar</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>

    <!--Tabela de dados-->
    <table-nfe :lista-nfe=formRule.listaNfe :list-loading=formRule.listLoading :descr-emit-dest=formRule.descrEmitDest
      :total-reg=formRule.totalReg @getlistnfe="getListaNfe"></table-nfe>
  </section>
</template>

<script>
import axios from "axios";
import { mask } from "vue-the-mask"; // https://vuejs-tips.github.io/vue-the-mask/
import tableNfe from "../../components/table-nfe.vue";
import { apiGetCnpj, apiGetListaNfeGeral } from "../../api/api";

const dtAtual = new Date();

export default {
  components: {
    tableNfe
  },
  directives: {
    mask
  },
  data () {
    return {
      formRule: {
        tipo: "C",
        cnpjObj: [],
        cnpjSel: "",
        listaNfe: [],
        selecao: "C",
        nfeChave: undefined,
        nfeNumero: undefined,
        nfeSerie: undefined,
        descrEmitDest: "Emit./Dest.",
        totalReg: 0,
        listLoading: false,
        pageSize: 10
      }
    };
  },
  methods: {
    changeSelecao () {
      // Valida se campos data estao nulos
      if (!this.formRule.dtIni) {
        this.formRule.dtIni = dtAtual;
      }
      if (!this.formRule.dtFin) {
        this.formRule.dtFin = dtAtual;
      }

      this.formRule.nfeChave = undefined;
      this.formRule.nfeNumero = undefined;
      this.formRule.nfeSerie = undefined;
      this.formRule.selecao = this.formRule.tipo;
    },
    cleanListaNfe () {
      this.formRule.listaNfe = [];
      this.formRule.totalReg = 0;
    },
    getListaNfe (pageNumber, pageSize) {
      this.formRule.listLoading = true;
      if (!pageSize) {
        this.formRule.totalReg = 0;
      }

      let params = {};
      let chave = "0";
      let numero = "abc";
      let serie = "";

      params["cnpj"] = this.formRule.cnpjSel;
      params["tipoConsulta"] = "especifica";
      if (this.formRule.tipo === "C") {
        if (this.formRule.nfeChave) {
          chave = this.formRule.nfeChave.replace(/\s/g, ""); //Remove espacos da chave
        }
        params["nfeChave"] = chave;
      } else {
        if (this.formRule.nfeNumero) {
          numero = this.formRule.nfeNumero;
        }
        if (this.formRule.nfeSerie) {
          serie = this.formRule.nfeSerie;
        }
        params["nfeNumero"] = numero;
        params["nfeSerie"] = serie;
      }

      if (pageSize && pageSize >= 0) {
        this.formRule.pageSize = pageSize;
      }

      this.formRule.listaNfe = [];
      apiGetListaNfeGeral(params)
        .then(res => {
          this.formRule.listaNfe = res;
          this.formRule.totalReg = Object.keys(res).length; // Como nao esta utilizando paginacao do B.D. conta os registros retornados no objeto
          this.formRule.listLoading = false;
        })
        .catch(error => {
          this.formRule.listLoading = false;
        });
    }
  },
  mounted () {
    var user = localStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      const cnpj = user.cnpj || "";
      // this.sysUserAvatar = user.avatar || ""
      apiGetCnpj(cnpj)
        .then(data => {
          this.formRule.cnpjObj = data;
          this.formRule.cnpjSel = data[Object.keys(data)[0]].cnpj;
        })
        .catch(error => {
          console.log(error);
        });
      //
      // this.getListaNfe()
    }
  }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/consulta-nfe/especifica.vue